import React from "react";
import { useLocation } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function ReportCountry() {
  const { state } = useLocation();
  const countryData = state?.countryData;
  const { reportName } = countryData || {};
console.log("statwe data",state)
  // Prepare the data for the bar chart
  const chartData = {
    labels: countryData?.data?.map((data) => data.year),
    datasets: [
      {
        label: `Revenue for ${countryData?.country}`,
        data: countryData?.data?.map((data) => data.value),
        backgroundColor: "rgba(146, 51, 81, 1)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
        borderRadius: 5,
        datalabels: {
          display: true, // Disable data labels
          align: 'end',
          anchor: 'end',
          formatter: (value) => `$${value.toFixed(2)}`, 
        },
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: `Market Data for ${countryData?.country}`,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `$${tooltipItem.raw.toFixed(2)}`; // Format the value to show currency
          },
        },
      },
    },
  };

  // Download chart as PNG
  const downloadChartAsPNG = () => {
    const canvas = document.getElementById("chartCanvas");
    html2canvas(canvas).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `${countryData?.country}_chart.png`;
      link.click();
    });
  };

  // Download chart as SVG (Note: You might need a different method for SVG export)
  // const downloadChartAsSVG = () => {
  //   const chartContainer = document.getElementById("chartCanvas");
    
  //   if (chartContainer) {
  //     html2canvas(chartContainer).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");  // Export as PNG
  //       const link = document.createElement("a");
  //       link.href = imgData;
  //       link.download = `${countryData?.country}_chart.png`;
  //       link.click();
  //     });
  //   }
  // };
  // Download data as Excel
  const downloadDataAsExcel = () => {
    const data = [
      ["Year", "Revenue"], // Header row
      ...countryData?.data?.map((data) => [data.year, data.value]), // Data rows
    ];

    const ws = XLSX.utils.aoa_to_sheet(data); // Create a worksheet
    const wb = XLSX.utils.book_new(); // Create a workbook
    XLSX.utils.book_append_sheet(wb, ws, "Revenue Data"); // Append sheet to workbook

    XLSX.writeFile(wb, `${countryData?.country}_data.xlsx`); // Export to Excel file
  };

  return (
    <div>
      {/* <h1 className="text-3xl font-bold text-gray-800 mb-4">{reportName}</h1> */}
      <h1 className="text-3xl font-bold text-gray-800 mb-4">
     {countryData?.country} market Size Study & Forecast
      </h1>
      {/* Info grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Revenue, 2023</h3>
          <p className="text-xl font-bold text-green-600"> {/* Revenue data */} </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Forecast, 2030</h3>
          <p className="text-xl font-bold text-blue-600"> {/* Forecast data */} </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">CAGR, 2024-2030</h3>
          <p className="text-xl font-bold text-purple-600"> {/* CAGR data */} </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Region</h3>
          <p className="text-xl font-bold text-yellow-600"> {/* Region data */} </p>
        </div>
      </div>

      {/* Bar Chart */}
      <div
        className="chart-container"
        style={{ width: "80%", height: "400px", margin: "auto" }}
      >
        <Bar
          id="chartCanvas"
          data={chartData}
          options={chartOptions}
        />
      </div>

      {/* Download options below the graph */}
      <div className="download-options text-center mt-6">
        <button
          onClick={downloadChartAsPNG}
          className="bg-blue-600 text-white px-4 py-2 rounded mr-2"
        >
          Download PNG
        </button>
        {/* <button
          onClick={downloadChartAsSVG}
          className="bg-green-600 text-white px-4 py-2 rounded mr-2"
        >
          Download SVG
        </button> */}
        <button
          onClick={downloadDataAsExcel}
          className="bg-yellow-600 text-white px-4 py-2 rounded"
        >
          Download Excel
        </button>
      </div>
    </div>
  );
}

export default ReportCountry;
